import React, { Suspense, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import NotFound from "components/NotFound";
import { Route, Switch, withRouter } from "react-router-dom";
import Settings from "components/Settings";
import Customers from "components/Management/Customers";
import Visitors from "components/Management/Visitors";
import SigninSheet from "components/Management/SigninSheet";
import LoadingPage from "components/common_components/LoadingPage";
import SecureRoute from "components/SecureRoute";
import NotAuthorized from "components/NotAuthorized";
import Menu from "components/Menu";
import Module from "components/Modules/Module";
import AppContext from "AppContext";
import HomePage from "./Home";
import ClientPortalPaymentDetail from "./ClientPortalPayments/ClientPortalPaymentDetail";
import Calendar from "components/Calendar";
import ChatPage from "components/Chat/Page";
import POS from "components/POS";
import Invoicing from "components/Invoicing";
import Forms from "components/Forms";
import Campaigns from "components/Campaigns";
import { Tenant } from "utils/tenants";
import ChainOfCustody from "components/ChainOfCustody";
import { hasPermission } from "utils/session";
import GoogleCalendar from "components/GoogleCalendar";

function Home(props) {
    const { allowedModules, setConfigurations, api } = useContext(AppContext);
    const { user } = useSelector((state) => state.Login);

    useEffect(() => {
        if (!user) return;
        api.Settings.Configurations.getAll({
            onSuccess: (response) => {
                setConfigurations(response);
            },
            onError: (error) => {
                console.error(error);
            },
        });
    }, [user, api.Settings.Configurations, setConfigurations]);

    return (
        <Suspense fallback={<LoadingPage />}>
            <Menu {...props}>
                <Switch>
                    <Route exact path="/" component={HomePage} />
                    {hasPermission(user, "home.work.access") && <Route exact path="/open-task/:id" component={HomePage} />}
                    <Route exact path="/cp-payments/:id" component={ClientPortalPaymentDetail} />
                    {Tenant.getFeatures().modules.enabled &&
                        allowedModules &&
                        allowedModules
                            .filter((x) => x.path && x.dbName && x.formName)
                            .map(({ code, path, dbName, formName, name }) => (
                                <SecureRoute
                                    key={`module-${code}`}
                                    path={path}
                                    render={(props) => <Module {...props} dbName={dbName} formName={formName} code={code} name={name} />}
                                />
                            ))}
                    {Tenant.getFeatures().internalChat.enabled && <SecureRoute exact path="/chat" component={ChatPage} />}
                    {Tenant.getFeatures().calendar.enabled && hasPermission(user, "calendar.access") && (
                        <SecureRoute exact path="/calendar" component={Calendar} />
                    )}
                    {Tenant.getFeatures().masterCalendar.enabled && hasPermission(user, "calendar.access") && (
                        <SecureRoute path="/master-calendar" component={GoogleCalendar} />
                    )}
                    <SecureRoute path="/customers" component={Customers} />
                    {Tenant.getFeatures().visitors.enabled && <SecureRoute path="/visitors" component={Visitors} />}
                    {Tenant.getFeatures().signinSheet.enabled && <SecureRoute path="/check-in" component={SigninSheet} />}
                    <SecureRoute path="/settings" component={Settings} />
                    {Tenant.getFeatures().pos.enabled && hasPermission(user, "pos.access") && <SecureRoute path="/pos" component={POS} />}
                    {Tenant.getFeatures().invoicing.enabled && hasPermission(user, "invoicing.access") && (
                        <SecureRoute path="/invoicing" component={Invoicing} />
                    )}
                    {Tenant.getFeatures().chainOfCustody.enabled &&
                        (hasPermission(user, "chain-of-custody.access") || hasPermission(user, "chain-of-custody.admin")) && (
                            <SecureRoute path="/chain-of-custody" component={ChainOfCustody} />
                        )}
                    {Tenant.getFeatures().forms.enabled && <SecureRoute path="/forms" component={Forms} />}
                    {Tenant.getFeatures().campaigns.enabled &&
                        (hasPermission(user, "campaigns.access") || hasPermission(user, "campaigns.admin")) && (
                            <SecureRoute path="/campaigns" component={Campaigns} />
                        )}
                    <Route exact path="/unauthorized" component={NotAuthorized} />
                    {allowedModules && <Route component={NotFound} />}
                </Switch>
            </Menu>
        </Suspense>
    );
}

export default withRouter(Home);
